import { connect } from 'react-redux'
import { toggleIndustry, toggleAll, toggleItemByName } from './actions'
import MenuTree from '../components/menutree/index';
import {updateViewPadding} from '../map/actions';
import {BUSSINESS_TOOLTIP} from './reducer';

const EVENTS_WORLD_URL = 'https://dom.lndb.lv/data/obj/916630.html';

const mapStateToPropsRes = (state) => {

  var someInActive = false;
  var cntAct = 0;
  for (var i = state.mapData.data.length - 1; i >= 0; i--) {

    if(!state.mapData.data[i].active) {
      someInActive = true;
    } else {
      cntAct++;
    }
  }

  return {
    squeeze: true,
    data: state.mapData.data,
    titleTooltip: BUSSINESS_TOOLTIP,
    cntAct: cntAct,
    updateTime: state.mapData.updateTime
  }
}

const mapDispatchToPropsRes = (dispatch) => {

  return {
    sidebarToggleCallback: (open) => {

      dispatch(updateViewPadding([0, 0, 0, (open ? 0 : 256)]));
    },
    clickHandler: ({lvl, parentN, n, item}) => {
        if (item.id === 'events_world') {
            window.open(EVENTS_WORLD_URL);

        } else if (item.id !== 'events') {
            if (lvl > 0) {
              dispatch(toggleIndustry({parent: parentN-1, current: n-1}));

            } else {
              dispatch(toggleIndustry({parent: -1, current: n-1}));
            }
        }
    },
    titleClickHandler: () => {

    //  dispatch(toggleAll());
    }
  }
}

const IndustriesContainer = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(MenuTree);

export default IndustriesContainer;



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapData/container.js